































































































import { Component, Watch, Mixins, Inject } from 'vue-property-decorator';
import { SettingsMixin } from '../../mixins';
import { Route } from 'vue-router';
import {required, numeric, minLength, and} from 'vuelidate/lib/validators';
import { Form, FormInput, Select } from '@/pages/profile/blocks';
import { Button } from '@/pages/profile/components';
import { Info, Message } from '../settings/components';
import IsMunicipalityMixin from '@/mixins/isMunicipalityCheck';
import { dadataService } from '@/services';
import { ISettins, OptionsType, AxiosInstance } from './types';
import AppCheckBox from "@/uikit/components/AppCheckBox/AppCheckBox.vue";

const addressMatchRequired = (value: string, context: any) => {
  return !(context.address_match) ? required(value) : true;
}

@Component({
  components: {
    AppCheckBox,
    Form,
    FormInput,
    Select,
    Info,
    Message,
    Button,
  },
})
export default class AddressSettings
  extends Mixins(IsMunicipalityMixin, SettingsMixin)
  implements ISettins
{
  @Inject() $api: AxiosInstance;

  addressOptions: any = [];
  citizenshipDict: any = [];

  get municipalitiesOptions() {
    const { municipalities } = this.state;
    return municipalities
      ? municipalities.map(({ name, id }: OptionsType) => ({
          text: name,
          value: id,
        }))
      : [];
  }
  get regionsDict() {
    const { regionsDict } = this.state;
    return regionsDict
      ? regionsDict.map(({ name, id }: OptionsType) => ({
          text: name,
          value: id,
        }))
      : [];
  }

  get isDisableMunicipality() {
    const isDisable = !(
      this.$store.state.regionProfile.regionId == this.user.region_id
    );
    if (isDisable) this.user.municipality_id = '';
    return isDisable;
  }

  get isMunicipalityNotEmpty() {
    const { user, $store } = this;
    if ($store.state.regionProfile.regionId == user.region_id) {
      return !!user.municipality_id;
    }
    else return true
  }

  get changed() {
    const { user, profile, v, $store } = this;
    if (v.$invalid) return false;
    return JSON.stringify(user) !== JSON.stringify(this.parceProfile(profile));
  }

  @Watch('profile', { immediate: true })
  resetUser() {
    this.reset();
  }

  /**
   * address_match
   * Uncomment if needs reset validation after address_match changed
   */
  @Watch('user.address_match')
  resetUserAfterAddressMatchChanged() {
    (this.$v as any).user.address_zip.$reset();
    const profileData = (this.profile ? this.parceProfile(this.profile) : {}) as any;
    this.$set(this.user, 'residence_registration_match', profileData?.residence_registration_match || '');
    this.$set(this.user, 'address_zip', profileData?.address_zip || '');
  }

  /**
   * @param vuelidateObject
   * Очередность данных в объекте валидации (validation) в данном случае важна
   * Хак с required остался
   */
  getError(vuelidateObject: any, additionalData: any | undefined): string {
    const keys = Object.keys(vuelidateObject);
    const errorField: string | undefined = keys
      .filter(el => !/^\$/.test(el))
      .find(el => !vuelidateObject[el]);
    const validationMap = new Map([
      ['required', 'Поле обязательно к заполнению'],
      ['numeric', `Неверный формат: ${additionalData?.numeric}`],
      ['minLength', `Неверный формат: ${additionalData?.minLength}`],
      [undefined, `Неверный формат ${additionalData?.field}`],
      ['required', 'Поле обязательно к заполнению'],
    ])
    return validationMap.get(errorField) as string;
  }

  validations() {
    const user: any = {
      zip_code: {
        numeric,
        minLength: minLength(6),
      },

      address_zip: {
        required: addressMatchRequired,
        numeric,
        minLength: minLength(6),
      },

      residence_registration_match: {
        minLength: minLength(3),
        required: addressMatchRequired,
      },

      municipality_id: {
        isNotEmpty: and((value: string, context: any) => {
          const {region_id} = context
          if (this.state.regionProfile.regionId == region_id) {
            return !!value
          }
          else {
            return true
          }
        }),
      }
    };

    return { user: { ...user } };
  }

  @Watch('user.address_match')
  handleAddressMatch(value: boolean) {
    // console.log(value);
    if (value) {
      (this.$v as any).user.address_zip.$reset();
      (this.$v as any).user.residence_registration_match.$reset();
      this.$set(this.user, 'address_zip', '');
      this.$set(this.user, 'residence_registration_match', '');
    }
  }

  mounted() {
    this.initSearchAddress();
    this.initCitizenship();
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    const { municipality_id } = this.user;
    if (municipality_id === '0') {
      next(false);
    } else {
      next();
    }
  }

  saveProfile() {
    (this.$v as any).user?.$touch();
    const { changed } = this;
    if (changed) this.submit();
  }

  async searchAddress(value: string) {
    if (value) {
      const token = this.$store.getters.dadataToken;
      const result = await dadataService(this.$api).getAddress(value, token);
      this.addressOptions = result;
    }
  }

  async initCitizenship() {
    const rezult = await dadataService(this.$api).getCitizenship();
    this.citizenshipDict = rezult.data.map((el: any) => {
      return {
        text: el.name,
        value: el.id,
      };
    });
  }

  initSearchAddress() {
    if (this.user.address) this.searchAddress(this.user.address);
  }

  parceProfile(value: any) {
    return {
      municipality_id: `${value!.municipality_id || ''}`,
      address: value!.address || '',
      zip_code: value!.zip_code || '',
      region_id: `${value.region_id}`,
      citizenship: value.citizenship || '',
      is_russian_work_permission: value.is_russian_work_permission === undefined ? false : value.is_russian_work_permission,
      address_match: value.address_match === undefined ? true : value.address_match,
      residence_registration_match: value.residence_registration_match || '',
      address_zip: value.address_zip || '',
    };
  }

  reset() {
    this.v.$reset();
    this.user = this.profile ? this.parceProfile(this.profile) : {};
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/address/AddressSettings.vue